module.exports = __webpack_public_path__ + "media/images/recruitment/designs/alpha-phi-rainbow-design-947a727d751c80d42f0d17c5218cad2b.svg";